export const toWeiFromGwei = (value) => {
  return value * Math.pow(10, 9)
}
